import notification from 'core/libs/helpers/notification';
import log from 'core/libs/logger';

export const resetTasks = () => ({
  type: 'RESET_TASKS',
});

export const saveTask = (taskId, isCorrect) => ({
  type: 'SAVE_TASK_RESULT',
  payload: {
    taskId,
    isCorrect,
  },
});

export const checkQuizResult = ({callback, id, answer, quizAttempt}) => (
  dispatch,
  getState,
) => {
  const body = JSON.stringify({
    quiz_attempt: quizAttempt,
    answer,
  });

  const {timestamp} = getState().quizzes;
  const currentTime = new Date().getTime();
  let quizTimeout;

  if (process.env.GATSBY_IS_STAGING) {
    quizTimeout = 15000;
  } else {
    quizTimeout = 40000;
  }
  if (currentTime >= timestamp + quizTimeout) {
    notification({id: 'server_took_long_time'});
    log('Quiz: The server took too long to respond', {
      currentUrl: typeof window !== 'undefined' && window.location.href,
    });
    callback({status: 'Timeout Error'});
    return;
  }

  dispatch({
    types: [
      'CHECK_QUIZ_RESULT_REQUEST',
      'CHECK_QUIZ_RESULT_SUCCESS',
      'CHECK_QUIZ_RESULT_FAILURE',
    ],
    config: {
      url: `school/quiztask/${id}/check/`,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
    },
    callback: (success, response) => {
      if (success) {
        dispatch(saveTask(id, response.data.is_valid_answer));
        callback(response.data);
      }
    },
    payload: {
      currentTime,
    },
  });
};

export default checkQuizResult;
